var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guild-item",class:{ selected: _vm.isSelected },on:{"click":_vm.guildClick}},[_c('img',{attrs:{"src":_vm.guildData.imageUrl,"alt":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.guildData.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }